import { App } from 'vue'
import { ModuleNamespace } from 'vite/types/hot'

/**
 * Register layouts in the app instance
 *
 * @param {App<Element>} app
 */
export function registerLayouts(app: App<Element>) {
  const layouts: Record<string, ModuleNamespace> = import.meta.glob('./*.vue', { eager: true })

  Object.entries(layouts).forEach(([, layout]) => {
    app.component(layout?.default?.__name || layout?.default?.name, layout?.default)
  })
}
